export default {"src":"https://cdn.jetlend.ru/_next/static/media/slider-chevron-right.ad70caa7.svg","height":15,"width":9,"blurWidth":0,"blurHeight":0};